import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  TextField,
  // SelectInput,
  ReferenceArrayInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
// import RichTextInput from '../components/inputs/RichTextInput';
// import RichTextField from '../components/fields/RichTextField';
import SelectArrayInput from '../components/inputs/SelectArrayInput';
import TagsInput from '../components/inputs/TagsInput';
import TranslatableField from '../components/fields/TranslatableField';
import TranslatableInput from '../components/inputs/TranslatableInput';
import { getTranslationByLocale } from '../utils/TranslationUtils';

export const FAQList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="identifier" />
      <TranslatableField source="question" label={props.translate('academy.question')} />
      <EditButton {...props} basePath="/faq" />
      <DeleteButton {...props} basePath="/faq" />
    </Datagrid>
  </List>
));

// eslint-disable-next-line no-shadow
const FAQTitle = t(({ record, translate, locale }) => (
  <span>{record ? translate('edit.title', { title: getTranslationByLocale(record.question, locale) }) : ''}</span>
));

export const FAQEdit = t((props) => (
  <Edit title={<FAQTitle />} {...props}>
    <SimpleForm>
      <TextInput source="identifier" options={{ fullWidth: true }} />
      {/* <SelectInput source="language" choices={[{ id: 'en', name: 'English' }, { id: 'sv', name: 'Svenska' }]} label={props.translate('language')} /> */}
      <TranslatableInput {...props} source="question" label={props.translate('academy.question')} />
      <TranslatableInput {...props} multiline source="answer" />
      <SelectArrayInput
        source="positions"
        label={props.translate('position')}
        options={{ fullWidth: true }}
        choices={[
          { id: 'restaurantManager', name: 'Restaurant Manager' },
          { id: 'steward', name: 'Steward' },
          { id: 'waiter', name: 'Waiter' },
          { id: 'barManager', name: 'Bar Manager' },
          { id: 'bartender', name: 'Bartender' },
          { id: 'chef', name: 'Chef' },
          { id: 'sousChef', name: 'Sous Chef' },
          { id: 'cook', name: 'Cook' },
          { id: 'dishwasher', name: 'Dish Washer' },
          { id: 'economy', name: 'Economy' },
          { id: 'prospect', name: 'Prospect' },
          { id: 'socialMediaManager', name: 'Social Media Manager' },
          { id: 'areaManager', name: 'Area Manager' },
        ]}
      />
      <ReferenceArrayInput source="tags" reference="faq" allowEmpty>
        <TagsInput />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
));

export const FAQCreate = t((props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="identifier" options={{ fullWidth: true }} />
      {/* <SelectInput source="language" choices={[{ id: 'en', name: 'English' }, { id: 'sv', name: 'Svenska' }]} label={props.translate('language')} /> */}
      <TranslatableInput {...props} source="question" label={props.translate('academy.question')} />
      <TranslatableInput {...props} multiline source="answer" />
      <SelectArrayInput
        source="positions"
        label={props.translate('position')}
        options={{ fullWidth: true }}
        choices={[
          { id: 'restaurantManager', name: 'Restaurant Manager' },
          { id: 'steward', name: 'Steward' },
          { id: 'waiter', name: 'Waiter' },
          { id: 'barManager', name: 'Bar Manager' },
          { id: 'bartender', name: 'Bartender' },
          { id: 'chef', name: 'Chef' },
          { id: 'sousChef', name: 'Sous Chef' },
          { id: 'cook', name: 'Cook' },
          { id: 'dishwasher', name: 'Dish Washer' },
          { id: 'economy', name: 'Economy' },
          { id: 'prospect', name: 'Prospect' },
          { id: 'socialMediaManager', name: 'Social Media Manager' },
          { id: 'areaManager', name: 'Area Manager' },
        ]}
      />
      <ReferenceArrayInput source="tags" reference="faq" allowEmpty>
        <TagsInput />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
));
